export * from "./textarea-component.module";
export * from "./textarea.component";
